<script setup lang="ts">
defineProps({
  label: {
    type: String,
    default: ""
  },
  type: {
    type: String,
    default: 'text'
  },
  required: {
    type: Boolean,
    default: false
  },
  options: Array<string>,
  error: Boolean
})

const model = defineModel()
</script>

<template>
  <select :class="`select border-b-2 ${error ? 'border border-english-vermillion' : 'border-light-gray'}`"
    v-model="model">
    <option value="">{{ label }}</option>
    <option v-for="option in options" :key="option" :value="option">{{ option }}</option>
  </select>
</template>
